<template>
  <div style="padding: 20px">
    <div style="padding-bottom: 20px">
      <select-area @areaListId="getAreaListId"/>
      <el-date-picker
          v-model="query.yearAndMonth"
          type="month"
          style="width: 160px;margin-right: 10px"
          value-format="YYYY-MM"
          placeholder="年月选择">
      </el-date-picker>
      <el-button type="primary" @click="selectTableData()">搜索</el-button>
      <el-button type="primary" @click="detailDialog=true">新增</el-button>
      <el-popconfirm @confirm="exportExcel" title="确定要导出吗？">
        <template #reference>
          <el-button v-permission="['areaRate:export']" type="primary"  icon="Download"
          >导出
          </el-button
          >
        </template>
      </el-popconfirm>
    </div>
    <!--    列表-->
    <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '16px' }"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header">
      <el-table-column width="180" show-overflow-tooltip="true" label="城市">
        <template #default="scope">
          <span>{{ scope.row.city }} ~ {{ scope.row.flag }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="areaName" label="校区" width="210"></el-table-column>
      <el-table-column prop="startZjCount" label="月初在籍" width="150"></el-table-column>
      <el-table-column prop="zjCount" label="在籍人数" width="150"></el-table-column>
      <el-table-column prop="courseCount" label="总课次" width="110"></el-table-column>
      <el-table-column prop="courseStuCount" label="总人数" width="110"></el-table-column>
      <el-table-column prop="oldTargetCount" label="原效比目标" width="110"></el-table-column>
      <el-table-column prop="updateCoachName" label="修改人" width="110"></el-table-column>

      <el-table-column prop="updateTime" label="修改时间" width="210"></el-table-column>
      <el-table-column prop="targetCount" label="效比目标" width="110"></el-table-column>
      <el-table-column prop="ratio" label="合计效比" width="210"></el-table-column>
      <el-table-column prop="accomplishRate" label="效比完成率" width="210">
        <template #default="scope">
          <el-progress :stroke-width="15" :percentage="scope.row.accomplishRate"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="详情" width="100" fixed="right" align="center">
        <template #default="scope">
          <el-button @click="detailDialog=true,detail = scope.row,initModifyData()" size="small"
                     style="padding: 0;margin: 0"
                     type="text">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页组件-->
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <!--    新增/修改 弹框-->
    <el-dialog
        title="新增/修改 效比目标"
        draggable
        v-model="detailDialog"
        width="800px">
      <el-form :model="detail" :rules="formRules" ref="formRuleRef" label-width="220px" class="mt-4">
        <el-form-item label="月份" prop="yearAndMonth">
          <el-date-picker
              v-model="detail.yearAndMonth"
              type="month"
              format="YYYY/MM"
              value-format="YYYY-MM"
              placeholder="请选择执行月份"
              @click.stop
              @calendar-change.stop style="width: 260px;margin-right: 10px"/>
        </el-form-item>

        <el-form-item label="校区" prop="areaId">
          <select-area :multiple-status="false" @areaListId="chooseAreaId"/>
        </el-form-item>
        <el-form-item label="本月效比目标" prop="efficiencyTarget">
          <el-input-number v-model="detail.efficiencyTarget" style="width: 260px;margin-right: 10px"></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import selectArea from "../../components/SelectArea";
import {loadAreaRate, updateAreaRate,exportEfficiencyRatio} from "../../api/coach";

export default {
  name: "AreaEfficiencyRate",
  components: {
    selectArea
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,

      //弹框
      detailDialog: false,
      // 查询入参
      query: {
        areaIdList: [],
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        year: null,
        month: null,
        yearAndMonth: null
      },
      //新增
      detail: {
        areaId: 0,
        efficiencyTarget: 0,
        targetCount:0,//兼容 返回的
        year: null,
        month: null,
        yearAndMonth: null
      },
      //必填,规则
      formRules: {
        efficiencyTarget: [{required: true, message: '请填写校区目标', trigger: 'blur'}]
      },//规则
    }
  },
  methods: {
    exportExcel(){
      if(this.query.yearAndMonth){
        [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
        exportEfficiencyRatio(this.query)
      }else {
        this.$message.error("请选择日期！");
      }
    },
    //年月日期格式化
    yearMonthDateFormat(val) {
      const date = new Date(val);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return [y, m];
    },
    //初始化修改数据
    initModifyData() {
      this.detail.yearAndMonth = this.query.yearAndMonth
      this.detail.efficiencyTarget=this.detail.targetCount;
    },
    //新增/修改 提交
    handleSubmit() {
      this.$refs.formRuleRef.validate(valid => {
        if (valid) {
          console.log(this.detail);
          //拆
          [this.detail.year, this.detail.month] = this.detail.yearAndMonth ? this.detail.yearAndMonth.split('-') : [null, null];
          updateAreaRate(this.detail).then(res => {
            if (res.code === 200) {
              this.$message.success(`操作成功！`);
            } else {
              this.$message.error(`操作失败！`);
            }
          })
        }
      })
    },
    //获取区域
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
    //选择单选的 新增/修改时的校区id
    chooseAreaId(val) {
      this.detail.areaId = val;
    },
    //分页点击
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.selectTableData();
    },

    //查询
    selectTableData() {
      this.tableLoading = true;
      //拆
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      loadAreaRate(this.query).then(val => {
        if (val.code === 200) {
          this.tableLoading = false;
          this.tableData = val.data.pageList.records;
          this.query.pageTotal = val.data.pageList.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    }
  },
  mounted() {
  },
  created() {
    //加载表格
    this.selectTableData();
  }
}
</script>

<style scoped>

</style>
